import { Button, Col, Select, Row, Form } from "antd";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import EmailIcon from "../../../assets/images/vectors/EmailIcon";
import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useOptions } from "../../../providers/OptionsProvider";

export const InvoiceFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowEmailModal,
  setShowModal,
  selectedRowKeys,
  setFilter,
  params,
  setShowCommonModal,
  showCommonModal,
  invoiceListRefecth,
}) => {
  const { configOptions } = useOptions();
  const [form] = Form.useForm();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const role_value = userData?.role_value;

  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  const modifiedDealer = getModifiedResponse(configOptions, "dealers");
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  const handleFormChange = (changedValues, allValues) => {
    // Update filter state when form values change
    Object.keys(changedValues).forEach((key) => {
      if (key === "Month") {
        const formattedMonth = changedValues[key]
          ? dayjs(changedValues[key]).format("YYYY-MM")
          : null;
        setFilter({ ...filter, Month: formattedMonth });
      } else if (key === "InvoiceTime") {
        setFilter({ ...filter, InvoiceTime: changedValues[key] });
      }
    });
  };

  useEffect(() => {
    const formValues = {};

    if (modParams?.Month) {
      formValues.Month = dayjs(modParams.Month, "YYYY-MM");
    }

    if (modParams?.InvoiceTime) {
      formValues.InvoiceTime = dayjs.unix(Number(modParams.InvoiceTime));
    }

    // Set form values without triggering onChange
    if (Object.keys(formValues).length > 0) {
      form.setFieldsValue(formValues);
    }
  }, [params]);

  return (
    <Form className="" form={form} onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="InvoiceTime"
              placeholder="Invoice Time"
              format="YYYY-MM-DD HH:mm" // 24-hour format
            />
          </Col>
          {![7, 8, 9].includes(logData.role_value) && (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Dealer"
                optionFilterProp="DealerNo"
                value={filter.DealerNo ? Number(filter.DealerNo) : undefined}
                onChange={(value) => setFilter({ ...filter, DealerNo: value })}
                options={modifiedDealer}
                style={{ width: "100%" }}
              />
            </Col>
          )}
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="Month"
              placeholder="Month"
              picker={"month"}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Paid"
              optionFilterProp="Paid"
              value={
                filter.Paid || filter.Paid === 0
                  ? Number(filter.Paid)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, Paid: value })}
              options={[
                {
                  value: 1,
                  label: "Yes",
                },
                {
                  value: 0,
                  label: "No",
                },
              ]}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
      </div>

      <div className="flex justify-between my-4 overflow-x-auto !items-center">
        <div className="flex items-center">
          <Button
            type="primary"
            className="mr-2 w-[104px] h-[30px] font-medium"
            onClick={handleFilter}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span>Apply</span>
          </Button>
          <Button
            className="reset-button w-[104px] h-[30px] font-medium"
            onClick={() => {
              form.resetFields();
              handleReset();
            }}
          >
            <HiArrowPath className="!text-[14px] font-medium" />
            Reset
          </Button>
          {[1, 2, 3].includes(role_value) && (
            <>
              <Button
                type="primary"
                className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
                disabled={selectedRowKeys?.length === 0 ? true : false}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <DeleteOutlined className="" />
                Delete
              </Button>
            </>
          )}

          {[1, 2, 3].includes(role_value) && (
            <Button
              type="primary"
              className="w-[104px] h-[32px] font-medium"
              onClick={() => setShowEmailModal(true)}
              disabled={selectedRowKeys?.length === 0 ? true : false}
            >
              <EmailIcon color="white" size={16} />
              Email
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
};
